const selectors = [
  'iframe[src*="bandcamp.com"]',
  'iframe[src*="player.vimeo.com"]',
  'iframe[src*="youtube.com"]',
  'iframe[src*="youtube-nocookie.com"]',
  'iframe[src*="spotify.com"]',
  'iframe[src*="kickstarter.com"][src*="video.html"]'
];

function wrapEmbed(embed: HTMLElement): HTMLElement {
  const parent = embed.parentNode as HTMLElement;

  // Recycle the existing container if the embed is already responsive.
  if (
    parent &&
    parent.tagName === "DIV" &&
    parent.childNodes.length === 1 &&
    parent.style.position === "relative"
  ) {
    return parent;
  }

  const wrapper = document.createElement("div");
  if (parent.tagName === "P") {
    parent.parentNode?.replaceChild(wrapper, parent);
  } else {
    parent.replaceChild(wrapper, embed);
  }
  wrapper.appendChild(embed);
  return wrapper;
}

function applyEmbed(embed: Element) {
  const embedEl = embed as HTMLElement;
  const parent = embedEl.parentNode as HTMLElement;

  if (parent && parent.classList.contains("responsive-embed")) {
    return;
  }

  const width = embedEl.offsetWidth;
  const height = embedEl.offsetHeight;
  const ratio = height / width;
  const wrapper = wrapEmbed(embedEl);

  wrapper.classList.add("responsive-embed");
  wrapper.style.position = "relative";
  wrapper.style.width = "100%";
  wrapper.style.paddingTop = "0";
  wrapper.style.paddingBottom = `${ratio * 100}%`;

  embedEl.style.position = "absolute";
  embedEl.style.width = "100%";
  embedEl.style.height = "100%";
  embedEl.style.top = "0";
  embedEl.style.left = "0";
}

export default function responsiveEmbeds() {
  document.querySelectorAll(selectors.join(",")).forEach(applyEmbed);
}
